import request from '@/utils/request'

export function  guanggao(data) {
  return request({
    url: '/invitation/type',
    method: 'get',
  })
}


